import { Box, Card, Rating, Stack, Typography } from '@mui/material'
import MDAvatar from 'components/MDAvatar'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import extractText from 'hooks/extractText'
import React from 'react'

const ProductCard = ({product}) => {
  return (
     <Card sx={{ p: 2 }}>
                <Box display="flex" >
                  <MDAvatar
                    src={product.medias[0].file_name}
                    alt={product.name}
                    size="md"
                    sx={{ width: 60, height: 60, borderRadius: "8px", mr: 2 }}
                    variant="rounded"
                  />
                  <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>

                    <MDTypography
                      variant="subtitle2"
                      fontWeight="bold"
                      title={product.name}
                      sx={{
                        mb: 0.5,
                        maxWidth: 160,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                      }}
                    >
                      {product.name.length > 22 ? product.name.slice(0, 22) + "..." : product.name}
                    </MDTypography>
                    <MDBox >
                      <MDTypography variant="button" color="primary" fontWeight="bold">
                        {Number(product.price).toLocaleString()} ر.س
                      </MDTypography>
                    </MDBox>
                  </Box>
                </Box>
                <MDBox sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>


                  <Typography color="text" sx={{
                    fontSize: 14,
                    // --- The Magic 4 Lines for Multi-line Truncation ---
                    display: '-webkit-box',
                    overflow: 'hidden',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,

                  }} >
                    {extractText(product.description)}
                  </Typography>
                  <Typography variant="p" color="text" sx={{ fontSize: 16 }}>
                    الكمية المباعة: <b>{product.order_items_count}</b>
                  </Typography>
                  <Typography variant="p" color="text" sx={{ fontSize: 16 }}>
                    المبيعات: <b>{product.product_sales_total}</b>
                  </Typography>
                </MDBox>

                <Stack spacing={1}>
                  <Rating name="half-rating-read" color="text" borderColor="text" value={product.avg_rating || 2.5} defaultValue={2.5} precision={0.5} readOnly />
                </Stack>

              </Card>
  )
}

export default ProductCard